module.exports = __webpack_public_path__ + "static/img/dfhj_bg1.9a6bcb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/nodeService/dfhj_bg1.png
// module id = dMX+
// module chunks = 0